export const CourseKind = {
  QUALIFICATION: 'QUALIFICATION',
  SKILL_SET: 'SKILL_SET',
  NON_VOCATIONAL: 'NON_VOCATIONAL',
  SHORT_COURSE: 'SHORT_COURSE',
} as const;

export type CourseKind = (typeof CourseKind)[keyof typeof CourseKind];
